export default "__VITE_ASSET__1260ef32__"